
import { isSet, optionsToKeyValuePairs } from "../../../../../../utils/commonUtils";
import { computationRules1 } from "./DrugScreenCollection";

export const ScreeningHA = (props)=>{
    // console.log('props.lookupsOptions',props.lookupsOptions);
    const stackedFieldStyle = {
        layout: 'stacked',
        showContainerBorder: false,
        labelWrap: false,
        isLabel: false,
      };
    const charts = [{
        type:'Grid',
        col:'col-md-3',
        data:[{
            type:"PatientDetails",
            employeeDetails:props.employeeDetails,
            visitDetails:props.visitDetails
        },{
            type:"CompanyDetails",
            companyDetails:props.companyDetails
        }],
    },{
        type:'Tab',
        col:'col-md-9',
        data:[
            {
                id:'hearing_details',
                label:'Hearing Details',
                data:[
        {
            label:'Activity Details - '+props.activityName,
            fields:[
                {
                    label:'Standard: Equal to 40 dB, in better ear (with or without hearing aid).',
                    type:'Label',
                    col:'col-12'                
                },
            {
                label:'Check if hearing aid used for test',
                col:'col-12',
                type:'RadioGroup',
                name:'check_hearing_aid_used',
                id:'check_hearing_aid_used',
                options:['Right Ear','Left Ear','Neither'],
            },
        ]
        },
        { 
            label:'Audiometric Test Results',
            note:'Standard: Equal to 40 dB, in better ear (with or without hearing aid).',
            fields:[
                {
                    label:'Right Ear',
                    type:'Label',
                    appendClass:'bg-light',
                    col:'col-12',
                },
                {
                    label:'500 Hz',
                    type:'Number',
                    rangeMax:40,
                    col:'col-4',
                    name:'audiometric_test_results_right_ear_500_hz',
                    id:'audiometric_test_results_right_ear_500_hz',
                },
                {
                    label:'1000 Hz',
                    type:'Number',
                    rangeMax:40,
                    col:'col-4',
                    name:'audiometric_test_results_right_ear_1000_hz',
                    id:'audiometric_test_results_right_ear_1000_hz',
                },
                {
                    label:'2000 Hz',
                    type:'Number',
                    rangeMax:40,
                    col:'col-4',
                    name:'audiometric_test_results_right_ear_2000_hz',
                    id:'audiometric_test_results_right_ear_2000_hz',
                },
                {
                    label:'3000 Hz',
                    type:'Number',
                    rangeMax:40,
                    col:'col-4',
                    name:'audiometric_test_results_right_ear_3000_hz',
                    id:'audiometric_test_results_right_ear_3000_hz',
                },
                {
                    label:'4000 Hz',
                    type:'Number',
                    rangeMax:40,
                    col:'col-4',
                    name:'audiometric_test_results_right_ear_4000_hz',
                    id:'audiometric_test_results_right_ear_4000_hz',
                },
                {
                    label:'6000 Hz',
                    type:'Number',
                    rangeMax:40,
                    col:'col-4',
                    name:'audiometric_test_results_right_ear_6000_hz',
                    id:'audiometric_test_results_right_ear_66000_hz',
                },
                {
                    label:'8000 Hz',
                    type:'Number',
                    col:'col-4',
                    rangeMax:40,
                    name:'audiometric_test_results_right_ear_8000_hz',
                    id:'audiometric_test_results_right_ear_8000_hz',
                },
                {
                    label:'Average',
                    type:'Number',
                    readOnly:true,
                    rangeMax:40,
                    col:'col-4',
                    name:'audiometric_test_results_right_ear_average',
                    id:'audiometric_test_results_right_ear_average',
                },
                {
                    type:'Blank',
                    col:'col-4',
                    name:'blank'
                },
                {
                    label:'Left Ear',
                    appendClass:'bg-light',
                    type:'Label',
                    col:'col-12',
                },
                {
                    label:'500 Hz',
                    type:'Number',
                    rangeMax:40,
                    col:'col-4',
                    name:'audiometric_test_results_left_ear_500_hz',
                    id:'audiometric_test_results_left_ear_500_hz',
                },
                {
                    label:'1000 Hz',
                    type:'Number',
                    rangeMax:40,
                    col:'col-4',
                    name:'audiometric_test_results_left_ear_1000_hz',
                    id:'audiometric_test_results_left_ear_1000_hz',
                },
                {
                    label:'2000 Hz',
                    type:'Number',
                    rangeMax:40,
                    col:'col-4',
                    name:'audiometric_test_results_left_ear_2000_hz',
                    id:'audiometric_test_results_left_ear_2000_hz',
                },
                {
                    label:'3000 Hz',
                    type:'Number',
                    rangeMax:40,
                    col:'col-4',
                    name:'audiometric_test_results_left_ear_3000_hz',
                    id:'audiometric_test_results_left_ear_3000_hz',
                },
                {
                    label:'4000 Hz',
                    type:'Number',
                    rangeMax:40,
                    col:'col-4',
                    name:'audiometric_test_results_left_ear_4000_hz',
                    id:'audiometric_test_results_left_ear_4000_hz',
                },
                {
                    label:'6000 Hz',
                    type:'Number',
                    rangeMax:40,
                    col:'col-4',
                    name:'audiometric_test_results_left_ear_6000_hz',
                    id:'audiometric_test_results_left_ear_6000_hz',
                },
                {
                    label:'8000 Hz',
                    type:'Number',
                    rangeMax:40,
                    col:'col-4',
                    name:'audiometric_test_results_left_ear_8000_hz',
                    id:'audiometric_test_results_left_ear_8000_hz',
                },
                {
                    label:'Average',
                    type:'Number',
                    readOnly:true,
                    rangeMax:40,
                    col:'col-4',
                    name:'audiometric_test_results_left_ear_average',
                    id:'audiometric_test_results_left_ear_average',
                },
                {
                    type:'Blank',
                    col:'col-4',
                    name:'blank'
                }
            ]
        },
        {
            label:'Notes',
            // labelStyle: "fw-semibold",
            fieldProps: stackedFieldStyle,
            fields:[
                {
                    label:'Notes',
                    col:'col-12',
                    type: "NewTextArea",
                    label: "Notes",
                    placeholder: "Add Comments",
                    className: "form-control form-control-solid",
                    name: "notes",
                    col: "col-12 border-0",
                    name:'notes',
                },
                // {
                //     label:'Suggested Result',
                //     type:'TextInput',
                //     disabled:true,
                //     options:isSet(props.lookupsOptions['chartResult'],[]),
                //     name:'suggested_status',
                // },
                {
                    type:'Blank',
                    name:'blank'
                },
                // {
                //     label:'Final Determination',
                //     type:'SelectList',
                //     options:isSet(props.lookupsOptions['chartResult'],[]),
                //     name:'status',
                // },
            
           
        ]
        },
        {
            label: 'Review / Completion',
            // labelStyle: 'fw-semibold',
            fields: [
                {
                    type: 'ProviderSignOff',
                    col: 'col-12',
                    fields: [
                        { label: 'Signature PIN', name: 'provider_pin', col: 'col-12' },
                        { label: 'Signature', type: 'NewSignature', name: 'provider_signature', col: 'col-12' },
                        { label: 'Date', type: 'Date', name: 'signed_date', col: 'col-12' },
                        // { label : "Suggested Result", disabled:true, placeholder:'Not Started',type: "TextInput", name: "suggested_status", col: "col-6"},
                        // { label : "Final Results", type: "SelectList", name: "status", col: "col-12", options:isSet(props.lookupsOptions['chartResult'],[]),statusBasedColor: true },
                        { label : "Final Results", type: "SelectList", name: "status", col: "col-12", options: optionsToKeyValuePairs(['Not Started','Pending','Normal','Abnormal','Negative','Positive','Dispensed','Administered','Failed','Passed','Non-Negative','Cancelled','Inconclusive']),statusBasedColor: true },
                        // { label : "Activity Status", type: "SelectList", name: "activity_status", col: "col-12", options: optionsToKeyValuePairs(['Not Started','Ordered','Completed','Cancelled']),statusBasedColor: true },
                        { label : "Activity Status", type: "SelectList", name: "activity_status", col: "col-12", options: optionsToKeyValuePairs(['Not Started','Pending','Pending Lab Confirmation','Pending MRO Confirmation','Ready for Review','Completed','Cancelled']),statusBasedColor: true },
                    ],
                },
            ],
        }
                ]
            },
            {
                id:'Images',
                label:'Images',
                data:[]
            }
        ]
    }];
    const defaultValue = {
        status:'Not Started',
        suggested_status:'Not Started',
        activity_status:'Not Started',
        // reason:'Pre-employment'
    };
    const headers = [{
        type: 'Tab',
        data: [
            {
                label: 'Hearing Details',
                id: 'hearing_details'
            },
            {
                label: 'Images',
                id: 'Images'
            }
        ]
    }];
    return {charts,defaultValue,headers,computationFunction: (formData,key) => ({...computationRules(formData,key), ...computationRules1(formData,key)})};
}



const computationRules = (formData,key)=>{
     
    let status = 'Not Started';
    let activity_status = 'Not Started';
    let returnData = {};
    const earPrefixes = ['right_ear_', 'left_ear_'];
    earPrefixes.forEach(earPrefix => {
        const frequencies = [500, 1000, 2000,3000,4000,6000,8000];
        let total = 0;
        
       
        frequencies.forEach(frequency => {
            const value = isSet(formData[`audiometric_test_results_${earPrefix}${frequency}_hz`], '');
            total += Number(value);
        });
        const average = Math.ceil(total / frequencies.length);
        returnData[`audiometric_test_results_${earPrefix}average`] = average;
    });

    const leftAverage = returnData[`audiometric_test_results_right_ear_average`];
    const rightAverage = returnData[`audiometric_test_results_left_ear_average`];

    if ((leftAverage <= 40 && leftAverage !== 0) || (rightAverage <= 40 && rightAverage !== 0)) {
        status = 'Passed';
        activity_status = 'Completed';
    } else if ((leftAverage === 0 || rightAverage === 0) && (leftAverage > 40 || rightAverage > 40)) {
        status = 'Failed';
        activity_status = 'Completed';
    } else if(leftAverage > 40 || rightAverage > 40){
        status = 'Failed';
        activity_status = 'Completed';
    }else{
        status = 'Pending';
        activity_status = 'Pending';
    }
    returnData = (key==='status' || key==='activity_status')?returnData:{...returnData,'status':status,'suggested_status':status,'activity_status':activity_status};
    return returnData;

}